import {Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import type {Nullish} from 'shared/web';

import type {SharedAdvertisementPreviewValue} from '../../utils/getAdvertisementPreviewSharedValues';

export function AdvertisementPreviewSharedValue<T>(props: {
  sharedValue: SharedAdvertisementPreviewValue<T>;
  formatValue: (value: T) => string | null;
}) {
  if (!props.sharedValue.isShared) {
    return <AdvertisementPreviewValue value={null} isNeutral />;
  }
  return (
    <AdvertisementPreviewValue
      value={isNil(props.sharedValue.value) ? null : props.formatValue(props.sharedValue.value)}
    />
  );
}

export function AdvertisementPreviewValue(props: {value: string | Nullish; isNeutral?: boolean}) {
  const color = match({hasValue: Boolean(props.value), isNeutral: Boolean(props.isNeutral)})
    .with({hasValue: false}, () => 'warning' as const)
    .with({isNeutral: true}, () => 'secondary' as const)
    .otherwise(() => 'primary' as const);
  return (
    <Text alternative color={color}>
      {props.value || i18n.t('page.advertisement.preview.notSet')}
    </Text>
  );
}
